import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { AlertCircleIcon, CloudIcon, MoonIcon, PillIcon, BookOpenIcon } from 'lucide-react';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const problems = [{
    icon: CloudIcon,
    text: 'Apps gringas ignoran ciclos irregulares latinas post-bebés.'
  }, {
    icon: MoonIcon,
    text: 'Diarios genéricos no capturan calorones 2am post-tamales.'
  }, {
    icon: PillIcon,
    text: 'Doctores apurados dicen "hormonas" sin explicar tu patrón personal.'
  }, {
    icon: BookOpenIcon,
    text: 'Remedios abuela sueltos sin horario = inconsistencia total.'
  }, {
    icon: AlertCircleIcon,
    text: 'Trackers sin cultura tuya no duran una semana.'
  }];
  return <section ref={ref} className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-208">
      <div className="max-w-6xl mx-auto" data-id="element-209">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-210">
          <h2 className="text-purple-deep text-4xl sm:text-5xl md:text-6xl font-bold font-heading mb-6" data-id="element-211">
            Esta mamá colombiana en Miami sabe exactamente ese pánico nocturno.
          </h2>
          <p className="text-gray-700 text-xl sm:text-2xl leading-relaxed max-w-4xl mx-auto" data-id="element-212">
            Calorones que te roban sueño, mañanas irritables con hijos, días sin
            control. Buscas en Google "menopausia latina" —solo foros gringos o
            pastillas caras. Tu tía decía "té de ruda", pero ¿cuándo? ¿Cómo
            trackear sin volverte loca?
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="bg-gradient-to-br from-purple-50 to-lavender-light/30 rounded-3xl p-8 sm:p-12 mb-12" data-id="element-213">
          <h3 className="text-purple-deep text-3xl sm:text-4xl font-bold font-heading mb-4 text-center" data-id="element-214">
            No eres "vieja hormonal".
          </h3>
          <p className="text-gray-800 text-2xl font-semibold text-center" data-id="element-215">
            Eres una mujer fuerte en transición —sin guía.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.5
      }} data-id="element-216">
          <h3 className="text-purple-deep text-3xl sm:text-4xl font-bold font-heading mb-8 text-center" data-id="element-217">
            Lo que probaste falló porque:
          </h3>
          <div className="space-y-6" data-id="element-218">
            {problems.map((problem, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.7 + index * 0.1
          }} className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-md border-l-4 border-coral" data-id="element-219">
                <problem.icon className="w-8 h-8 text-coral flex-shrink-0 mt-1" data-id="element-220" />
                <p className="text-gray-800 text-lg sm:text-xl leading-relaxed" data-id="element-221">
                  {problem.text}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}